import React, {useState, useEffect} from 'react'

import { connect } from 'react-redux';

import {getFileList, importFileData, deleteFile} from 'actions/uploadFile'
import Spinner from 'components/common/Spinner';

// reactstrap components
import {
  Button,
  Modal,
  Table,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

import CheckOPKModal from './CheckOpkModal'
import ValidationModal from './ValidationModal'
import { ToastContainer, toast } from 'react-toastify';

const FileTable = ({UploadFile : {uploadedFile, fileList, loading, importLoading,file_data, importError}, getFileList, importFileData, deleteFile}) => {
  const [modalConfig, setModalConfig] = useState({
    isShow: false,
    fileID: null,
    getChecker:null
  })
  const [waitingForImport, setWaitingForImport] = useState(false)
  useEffect(() => {
    getFileList()
    // eslint-disable-next-line
  }, [])

    const handleCheckOpk = (e, checkerName, fileID) => {
      e.preventDefault();
      
        setModalConfig(prevState => {
          const newState = {
            ...prevState,
            isShow: true,
            fileID: fileID,
            getChecker: checkerName
          }
          return(newState)
        })
    }
    const [validateModal, setValidateModal] = useState({ show: false, fileID: null })
    const handleValidate = (e, id) => {
      e.preventDefault();
      setValidateModal({show: true, fileID: id})
    }
    const dismissValidate = () => {
      setValidateModal({ show: false, fileID: null })
    }

    const modalDismiss = () => {
      setModalConfig(prevState => {
          
          return({
            ...prevState,
            isShow: false
          })
        })

    }

    const handleImport = (e, id) => {
      handleCheckOpk(e, 'getImport', id)
      setWaitingForImport(true)
      importFileData(id)
    }
    useEffect(() => {
      if(!importLoading&&waitingForImport){ 
        modalDismiss()
        setWaitingForImport(false)
        toast.info(<>
          Podsumowanie Importu:
          <ul>
          { Object.entries(file_data).map(([key,value])=>
              <li key={key} style={value==="Błąd w arkuszu"?{"color":"red"}:{"color":"inherit"}}>{key +": "+value} </li>
            )
          }
         </ul>
        </>, { position: "bottom-right" })
        if (importError===null) toast.info('Zakończono import!', { position: "bottom-right" })
        else toast.error('W trakcie importu wystąpił błąd!', { position: "bottom-right" })
      }
    }, [importLoading])

    const [deleteModal, setDeleteModal] = useState({show: false, id: null, name: '', loading: false})
    const handleDelete = (e, id, name) => {
      e.preventDefault()
      setDeleteModal({show: true, id: id, name: name, loading: false})
    }
    const dismissDelete = () =>{
      setDeleteModal({show: false, id: null, name: '', loading: false})
    }

    useEffect(() => {
      if(!loading&&deleteModal.show){ 
        getFileList()
        dismissDelete()
        toast.info('Pomyślnie usunięto plik', { position: "bottom-right" })
      }
    }, [loading])

    return (
        <>
          <ToastContainer />
          <Row>
            <Col className="ml-auto mr-auto" md="11">
              <h2 className="h4 title">
                <small>Lista przesłanych plików</small>
              </h2>
              {false 
              ? (<div style={{minHeight: '90vh'}}  className="text-center">
                <span>
                  <Spinner/><br/>
                  Trwa wczytywanie danych, proszę czekać...
                  </span>
              </div>)
            : (
              <Table striped>
                <thead className='smallerFont'>
                  <tr>
                    <th>Nazwa Pliku</th>
                    <th>Data Przesłania</th>
                    {/* <th>Sprawdzenie kont<br/>zespołu "4"</th> */}
                    {/* <th>Sprawdzenie kont<br/>zespołu "5"</th> */}
                    <th className='text-center'>Walidacja pliku</th>
                    <th className="text-right">Opcje</th>
                  </tr>
                </thead>
                <tbody>
                    {fileList && fileList.map((fileItem, idx) => {
                        const uploadDate = new Date(fileItem.date)
                        return(
                            <tr key={fileItem.id}>

                    <td>{fileItem.name}</td>
                    <td>{`${uploadDate.toLocaleString()}`}</td>
                    {/* <td>
                        <Button
                            className="btn-link mr-1"
                            color={fileItem.was_checked_four ? ("success"):("danger")}
                            data-toggle="tooltip"
                            data-id={fileItem.id}
                            id={`getCheckFour-${idx}`}
                            size="sm"
                            type="button"
                            onClick = {(e) => {handleCheckOpk(e, 'getCheckFour', fileItem.id)}}
                            // disabled={idx!==0}
                            // disabled = {fileItem.was_checked_four} 
                        >
                          {fileItem.was_checked_four ? (
                             <i className="fas fa-check"></i>
                              ) : (
                              <i className="fas fa-times"></i>
                            )}
                        </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="top"
                        target={`getCheckFour-${idx}`}
                      >
                         {fileItem.was_checked_four ? (
                            <>konta rodzajowe "4" zostały sprawdzone</>
                            ) : (
                            <>konta rodzajowe "4" nie zostały sprawdzone</>
                            )}
                      </UncontrolledTooltip>
                    </td>
                    <td>
                        <Button
                            className="btn-link mr-1"
                            color={fileItem.was_checked_five ? ("success"):("danger")}
                            data-toggle="tooltip"
                            data-id={fileItem.id}
                            id={`getCheckFive-${idx}`}
                            size="sm"
                            type="button"
                            onClick={(e) => {handleCheckOpk(e, 'getCheckFive', fileItem.id)}}
                            // disabled={idx!==0}
                            // disabled = {fileItem.was_checked_five} 
                        >
                            {fileItem.was_checked_five ? (
                              <i className="fas fa-check"></i>
                              ) : (
                              <i className="fas fa-times"></i>
                            )}
                        </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="top"
                        target={`getCheckFive-${idx}`}
                      >
                        {fileItem.was_checked_five ? (
                          <>konta rodzajowe "5" zostały sprawdzone</>
                          ) : (
                          <>konta rodzajowe "5" nie zostały sprawdzone</>
                          )}
                      </UncontrolledTooltip>
                    </td> */}
                    <td className='text-center'>
                        <Button
                            className="btn-link mr-1"
                            color={fileItem.was_checked_five&&fileItem.was_checked_four ? ("success"):("danger")}
                            data-toggle="tooltip"
                            data-id={fileItem.id}
                            id={`validate-${idx}`}
                            size="sm"
                            type="button"
                            onClick={(e) => {handleValidate(e, fileItem.id)}}
                            aria-label='Sprawdź poprawność pliku'
                            // disabled={idx!==0}
                            // disabled = {fileItem.was_checked_five} 
                        >
                            {fileItem.was_checked_five&&fileItem.was_checked_four ? (
                              <i className="fas fa-check"></i>
                              ) : (
                              <i className="fas fa-times"></i>
                            )}
                        </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="top"
                        target={`validate-${idx}`}
                      >
                        {fileItem.was_checked_five ? (
                          <>plik pomyślnie przeszedł walidację</>
                          ) : (
                          <>kliknij, żeby sprawdzić plik</>
                          )}
                      </UncontrolledTooltip>
                    </td>
                    {/* actions */}
                    <td className="td-actions text-right">
                      <Button
                        className="btn-link mr-1"
                        color="info"
                        data-toggle="tooltip"
                        id={`import-${idx}`}
                        size="sm"
                        type="button"
                        disabled={(!fileItem.was_checked_four || !fileItem.was_checked_five||fileItem.data_imported) }//|| idx!==0}
                        onClick={(e)=>{handleImport(e, fileItem.id)}}
                        aria-label='Importuj dane z pliku'
                      >
                        <i className="fas fa-upload"></i>
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="top"
                        target={`import-${idx}`}
                      >
                        Importuj dane z pliku
                      </UncontrolledTooltip>

                      <Button
                        className="btn-link mr-1"
                        color="success"
                        data-toggle="tooltip"
                        id={`export-${idx}`}
                        href={fileItem.file}
                        size="sm"
                        type="button"
                        aria-label='Pobierz plik'
                        >
                        <i className="fas fa-download"></i>
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="top"
                        target={`export-${idx}`}
                      >
                        Pobierz plik
                      </UncontrolledTooltip>

                      <Button
                        className="btn-link mr-1"
                        color="danger"
                        data-toggle="tooltip"
                        id={`remove-${idx}`}
                        size="sm"
                        type="button"
                        onClick={(e)=>{handleDelete(e, fileItem.id, fileItem.name)}}
                        aria-label='Usuń plik'
                      >
                        <i className="fas fa-trash-alt"></i>
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="top"
                        target={`remove-${idx}`}
                      >
                        Usuń plik
                      </UncontrolledTooltip>
                      
                    </td>

                    </tr>
                        )
                    })}
                </tbody>
              </Table> 
              )}
              
            </Col>
          </Row>
          {modalConfig.isShow && <CheckOPKModal 
            show={modalConfig.isShow} 
            modalDismiss={modalDismiss} 
            fileID={modalConfig.fileID}
            getChecker={modalConfig.getChecker}
            updateTable={()=>{getFileList()}}/> }
          {validateModal.show && <ValidationModal 
            show={validateModal.show} 
            modalDismiss={dismissValidate} 
            fileID={validateModal.fileID}
            updateTable={()=>{getFileList()}}/> }     
          <Modal isOpen={deleteModal.show}>
            {deleteModal.loading?                
            <div className="modal-header">
              <h5 className="modal-title text-center" id="exampleModalLabel" >
                        <Spinner /><br/> Ładowanie...            
              </h5>
            </div>:<>
              <div className="modal-header">
                <button className="close" type="button" onClick={()=>dismissDelete()} >
                  <span>×</span>
                </button>
                <h5 className="modal-title text-center" id="exampleModalLabel" >
                    Ostrzeżenie
                </h5>
              </div>
              <div className="modal-body">
                Czy na pewno chcesz usunąć plik {deleteModal.name}?
              </div>
              <div className="modal-footer">
                <div className="left-side">
                  <Button className="btn-link" color="danger" type="button" onClick={() => {
                    deleteFile(deleteModal.id);
                    setDeleteModal({...deleteModal, loading: true})
                    }} >
                    Tak
                  </Button>
                </div>
                <div className="divider" />
                <div className="right-side">
                  <Button className="btn-link" color="default" type="button" onClick={()=> {dismissDelete()}} >
                    Anuluj
                  </Button>
                </div>
              </div>
            </>}
          </Modal>
        </>
    )
}

const mapStateToProps = (state) => ({
  UploadFile: state.UploadFile,
});

export default connect(mapStateToProps, {getFileList, importFileData, deleteFile})(FileTable)
